import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class CityListService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	getActiveCitiesByState(state:string,token) {
		return this.http
		.get(this.apiUrl + "city/v1/getcitybystate/"+state, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json()).catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/city/service/city-list/city-list.service.ts